module.exports = __webpack_public_path__ + "static/img/sox4.30bf94d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/furnitures/sox4.png
// module id = lczJ
// module chunks = 0